import React from 'react';
import Icon from '../../../components/AppIcon';

const ExitPipelineCard = ({ stats }) => {
  return (
    <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="bg-amber-100 p-2 rounded-lg">
          <Icon name="TrendingDown" size={24} className="text-amber-600" />
        </div>
        <h2 className="text-xl font-bold text-gray-900">Exit Pipeline</h2>
      </div>

      {/* Stats Grid */}
      <div className="space-y-4">
        <div className="bg-gradient-to-r from-amber-50 to-amber-100 rounded-lg p-4 border border-amber-200">
          <div className="flex items-center justify-between mb-2">
            <p className="text-sm text-amber-700 font-medium">Active Departures</p>
            <Icon name="Users" size={20} className="text-amber-600" />
          </div>
          <p className="text-3xl font-bold text-amber-900">{stats?.activeDepartures || 0}</p>
        </div>

        <div className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-lg p-4 border border-blue-200">
          <div className="flex items-center justify-between mb-2">
            <p className="text-sm text-blue-700 font-medium">Average Completion</p>
            <Icon name="BarChart3" size={20} className="text-blue-600" />
          </div>
          <p className="text-3xl font-bold text-blue-900">{stats?.averageCompletion || 0}%</p>
        </div>

        <div className="bg-gradient-to-r from-red-50 to-red-100 rounded-lg p-4 border border-red-200">
          <div className="flex items-center justify-between mb-2">
            <p className="text-sm text-red-700 font-medium">Critical Deadlines</p>
            <Icon name="AlertCircle" size={20} className="text-red-600" />
          </div>
          <p className="text-3xl font-bold text-red-900">{stats?.criticalDeadlines || 0}</p>
        </div>

        <div className="bg-gradient-to-r from-purple-50 to-purple-100 rounded-lg p-4 border border-purple-200">
          <div className="flex items-center justify-between mb-2">
            <p className="text-sm text-purple-700 font-medium">Pending Final Pay</p>
            <Icon name="DollarSign" size={20} className="text-purple-600" />
          </div>
          <p className="text-3xl font-bold text-purple-900">{stats?.pendingFinalPay || 0}</p>
        </div>

        <div className="bg-gradient-to-r from-orange-50 to-orange-100 rounded-lg p-4 border border-orange-200">
          <div className="flex items-center justify-between mb-2">
            <p className="text-sm text-orange-700 font-medium">Assets Outstanding</p>
            <Icon name="Package" size={20} className="text-orange-600" />
          </div>
          <p className="text-3xl font-bold text-orange-900">{stats?.assetsOutstanding || 0}</p>
        </div>
      </div>

      {/* Compliance Alerts */}
      <div className="mt-6 pt-6 border-t border-gray-200">
        <h3 className="text-sm font-semibold text-gray-700 mb-3">PNG Compliance Status</h3>
        <div className="space-y-2">
          <div className="flex items-center justify-between text-sm">
            <span className="text-gray-600">NASFUND Closure</span>
            <Icon name="CheckCircle" size={16} className="text-green-600" />
          </div>
          <div className="flex items-center justify-between text-sm">
            <span className="text-gray-600">Tax Clearance</span>
            <Icon name="Clock" size={16} className="text-amber-600" />
          </div>
          <div className="flex items-center justify-between text-sm">
            <span className="text-gray-600">Employment Act</span>
            <Icon name="CheckCircle" size={16} className="text-green-600" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExitPipelineCard;